import { useEffect, useState } from 'react';
import { floorLayoutList } from './components/Filter';
import { DisclaimerCard } from 'components/DisclaimerCard';
import { FloorDetail } from './components/FloorDetail';
import { FloorPlan } from './components/FloorPlan';
import { FloorPalette } from './components/FloorPalette';
import { ApartmentInfo } from 'components/ApartmentInfo';

import './style.scss';
import DropdownMenu from 'components/DropdownMenu';
import { InfoCircle } from 'assets/icons/InfoCircle';
import { SettingControl } from 'components/SettingControl';
import { usePageTracking } from 'hooks/usePageTracking';

const MatBangTangPage = () => {
  usePageTracking('floor-plan');
  // Initialize with first building's first segment and floor
  const initialBuilding = 'viz-1';
  const initialSegment = Object.keys(
    floorLayoutList[initialBuilding].segments
  )[0];
  const initialFloor =
    floorLayoutList[initialBuilding].segments[initialSegment][0];

  const [selectedBuilding, setSelectedBuilding] = useState(initialBuilding);
  const [selectedSegment, setSelectedSegment] = useState(initialSegment);
  const [selectedFloor, setSelectedFloor] = useState(initialFloor);
  const [showApartmentInfo, setShowApartmentInfo] = useState({
    isOpen: false,
    data: null,
  });
  const [clickedApartment, setClickedApartment] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const handleChangeBuilding = (buildingId) => {
    if (!buildingId) return;

    // Get first segment and floor for new building
    const firstSegment = Object.keys(floorLayoutList[buildingId].segments)[0];
    const firstFloor = floorLayoutList[buildingId].segments[firstSegment][0];

    setSelectedBuilding(buildingId);
    setSelectedSegment(firstSegment);
    setSelectedFloor(firstFloor);
  };

  // eslint-disable-next-line no-unused-vars
  const handleChangeSegment = (segmentId) => {
    if (!segmentId) return;

    // Get first floor for new segment
    const firstFloor = floorLayoutList[selectedBuilding].segments[segmentId][0];

    setSelectedSegment(segmentId);
    setSelectedFloor(firstFloor);
  };

  // eslint-disable-next-line no-unused-vars
  const handleChangeFloor = (floorId) => {
    if (!floorId) return;
    setSelectedFloor(floorId);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    return () => {
      setShowApartmentInfo(false);
    };
  }, []);

  return (
    <div className="mat-bang-tang-page">
      {showApartmentInfo.isOpen && (
        <ApartmentInfo
          data={showApartmentInfo.data}
          onBack={() =>
            setShowApartmentInfo({
              isOpen: false,
              data: null,
            })
          }
        />
      )}

      {!showApartmentInfo.isOpen && (
        <>
          {/* <Filter
            onChangeBuilding={handleChangeBuilding}
            onChangeSegment={handleChangeSegment}
            onChangeFloor={handleChangeFloor}
            selectedBuilding={selectedBuilding}
            selectedFloor={selectedFloor}
            selectedSegment={selectedSegment}
          /> */}

          <div className="extended-info">
            <div className="disclaimer-card-container">
              <DisclaimerCard />
            </div>
            <FloorPalette />
            <FloorDetail
              selectedBuilding={selectedBuilding}
              selectedSegment={selectedSegment}
            />
          </div>

          <div className="actions">
            <DropdownMenu className="dropdown-mobile">
              <DropdownMenu.Trigger>
                <InfoCircle />
              </DropdownMenu.Trigger>
              <DropdownMenu.Content align="end" side="bottom" sideOffset={16}>
                <DisclaimerCard />
              </DropdownMenu.Content>
            </DropdownMenu>
            <SettingControl />
          </div>
        </>
      )}

      <FloorPlan
        onShow={(data) => setShowApartmentInfo({ isOpen: true, data })}
        selectedBuilding={selectedBuilding}
        selectedFloor={selectedFloor}
        selectedSegment={selectedSegment}
        clickedApartment={clickedApartment}
        setClickedApartment={setClickedApartment}
      />
    </div>
  );
};

export default MatBangTangPage;
